import { TranslationFunction } from "@home-finance-manager/shared"
import {
  createCreateExpenseCategoryValidator,
  createUpdateExpenseCategoryValidator,
} from "@home-finance-manager/shared/validators/expense_categories.validator.factory"

/**
 * Create translated category validation schemas
 * @param t - Translation function
 */
export const createTranslatedCategorySchemas = (t: TranslationFunction) => {
  // Use factory functions from shared package
  return {
    createCategorySchema: createCreateExpenseCategoryValidator(t),
    updateCategorySchema: createUpdateExpenseCategoryValidator(t),
  }
}
